<template>
  <cTable
    ref="table"
    :fields="fields"
    :modals="modals"
    :header="header"
    :methods="methods"
  >
  </cTable>
</template>

<script>
import {
  getList,
  del,
  update,
  add,
  getDetails,
  getConfig,
} from "@/api/finance/hw_surcharge";
import cTable from "@/base/common/index";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getCurrency } from "@/api/finance/currency";
/* import { getAgent } from "@/api/tracker/agent";
import { getAllClient } from "@/api/user/client";
import { getChargingType } from "@/api/double/list";
import { getConfig,getSubjectCost } from "@/api/tracker/cost_page"; */
export default {
  name: "hw_surcharge",
  components: {
    cTable,
  },
  async created() {
    this.configs = (await getConfig()).data.payload;
    this.client = (await getAllClient()).data.payload.rows;
    this.companies = (await getCompanies()).data.payload;
    this.client.unshift({ account: "*", id: 0 });
    this.companies.unshift({ title: "*", id: 0 });

    this.header.searchs.forEach(async (item) => {
      if (item.key === "shipment_type") item.options = this.configs.order_type;
      if (item.key === "client_id") item.options = this.client;
      if (item.key === "company_id") item.options = this.companies;
    });
  },
  methods: {},
  data() {
    let that = this;
    return {
      configs: {},
      client: [],
      companies: [],
      unit: [],
      bubble: [],
      currencyList: [],
      SubjectCost: [],
      methods: {
        list(params) {
          if (params.target_type === 2) {
            params.client_id = params.company_id;
          }
          return getList(params);
        },
        del,
        update,
        add,
        getDetails,
        getConfig,
      },
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let list = JSON.parse(JSON.stringify(this.list));
              list.map((t) => {
                t.data_type = 1;
                t.start_time = ~~(new Date(t.start_time).getTime() / 1000);
                t.end_time = ~~(new Date(t.end_time).getTime() / 1000);
              });
              row.other_fee_rules = list;
              this.$page
                .handleRequestMethods(row.id ? "update" : "add", row, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 1300,
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              target_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              shipment_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "array",
                },
              ],
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              op_fee_charge_mode: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
            },
          },
          grid: [
            { target_type: 12, client_id: 12 },
            { shipment_type: 12, currency: 12 },
            { op_fee_charge_mode: 12, op_fee: 12 },
            { overload_fee: 12, max_overload_fee: 12 },
            { overweight_fee: 12, material_fee: 12 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: this.$tz("操作费,计算方式"),
              key: "op_fee_charge_mode",
              component: "Select",
              placeholder: () => this.$tz("操作费,计算方式"),
              options: [],
              optionsFn: "",
              default: 1,
              optionsKey: "OP_FEE_CHARGE_MODE",
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 3,
              },
            },
            {
              key: "target_type",
              name: () => this.$t("CollectionUser"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("CollectionUser");
              },
              options: [
                { label: this.$t("b2bClient"), value: 1 },
                { label: this.$t("branchOffice"), value: 2 },
              ],
              clearable: false,
              default: 1,
              disabled: ({ row }) => row.id,
              methods: {
                "on-change": ({ value, field, fields, formData }) => {
                  formData["client_id"] = "";
                  fields.forEach((t) => {
                    if (t.key === "client_id") {
                      t.options = value === 1 ? this.client : this.companies;
                    }
                  });
                },
              },
            },
            {
              key: "client_id",
              name: ({ formData }) => {
                return formData["target_type"] === 1
                  ? this.$t("b2bClient")
                  : this.$t("branchOffice");
              },
              component: "Select",
              placeholder: (data) => {
                return (
                  this.$t("select") +
                  (data && data.formData && data.formData["target_type"] === 1
                    ? this.$t("b2bClient")
                    : this.$t("branchOffice"))
                );
              },
              options: [],
              config: {
                label({ formData, row }) {
                  return formData && formData["target_type"] === 1
                    ? row["account"]
                    : row["title"];
                },
                value: "id",
              },
              disabled: ({ row }) => row.id,
              methods: {
                list: ({ row, field }) => {
                  field.options =
                    row["target_type"] === 1 ? this.client : this.companies;
                  console.log("options", this, row["target_type"]);
                },
              },
            },
            {
              key: "shipment_type",
              name: () => this.$t("order_type_t"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              options: [],
              config: {
                label: "value",
                value: "key",
              },
              bind: {
                multiple: true,
              },
              disabled: ({ row }) => row.id,
              methods: {
                list: ({ field }) => {
                  field.options = this.configs.order_type;
                },
              },
            },
            {
              name: this.$t("toCurrency"),
              key: "currency",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("toCurrency"),
              options: [],
              config: {
                label: "title",
                value: "code",
              },
              methods: {
                list({ field }) {
                  getCurrency().then((res) => {
                    if (res.data.status) {
                      field.options = res.data.payload.rows;
                    }
                  });
                },
              },
            },
            {
              key: "op_fee",
              name: () => this.$t("extra_charge"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              default: 0,
              placeholder() {
                return this.$t("enter") + this.$t("extra_charge");
              },
            },
            {
              key: "overload_fee",
              name: () => this.$t("overload_fee"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              default: 0,
              placeholder() {
                return this.$t("enter") + this.$t("overload_fee");
              },
            },
            {
              key: "material_fee",
              name: () => this.$t("material_fee"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("material_fee");
              },
              default: 0,
            },
            {
              key: "overweight_fee",
              name: () => this.$t("overweight_fee"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("overweight_fee");
              },
              default: 0,
            },
            {
              key: "max_overload_fee",
              name: () => this.$t("numMax") + this.$t("overload_fee"),
              component: "InputNumber",
              bind: {
                style: "width:100%",
              },
              placeholder() {
                return (
                  this.$t("enter") + this.$t("numMax") + this.$t("overload_fee")
                );
              },
              default: 0,
            },
          ],
          table: {
            config: {
              height: 300,
              form: true,
            },
            fields: [
              {
                name: this.$tz("费用科目"),
                key: "expense_item_id",
                component: "Select",
                placeholder: () => this.$tz("费用科目"),
                options: [],
                optionsFn: "expenseItem",
                optionsKey: "",
                default: "",
                required: true,
                formType: "number",
                minWidth: 120,
              },
              {
                name: this.$tz("计算方式"),
                key: "charge_mode",
                component: "Select",
                placeholder: () => this.$tz("计算方式"),
                options: [],
                optionsFn: "",
                optionsKey: "COLLECTION_METHOD",
                default: "",
                required: true,
                formType: "number",
                minWidth: 120,
              },
              {
                name: this.$tz("单价"),
                key: "charge_value",
                component: "InputNumber",
                default: 0,
                required: true,
                bind: {
                  border: true,
                  min: 0,
                  step: 0.01,
                  style: "width:100%",
                },
                default: 0,
                minWidth: 120,
              },
              {
                name: this.$tz("币种"),
                key: "charge_currency",
                component: "Select",
                placeholder: () => this.$tz("币种"),
                options: [],
                optionsFn: "getCurrency",
                optionsKey: "",
                default: "",
                required: true,
                minWidth: 120,
              },
              {
                name: this.$tz("状态"),
                key: "status",
                component: "Select",
                placeholder: () => this.$tz("状态"),
                options: [],
                optionsFn: "EnableDisableNumber",
                optionsKey: "",
                default: 1,
                clearable: false,
                minWidth: 120,
                formType: "number",
                required: true,
              },
              {
                name: () => this.$tz("开始时间"),
                key: "start_time",
                placeholder: () => this.$tz("开始时间"),
                component: "DatePicker",
                bind: {
                  type: "date",
                },
                methods: {
                  format: ({ value }) => new Date(value).getTime(),
                },
                required: true,
                minWidth: 150,
              },
              {
                name: () => this.$tz("结束时间"),
                key: "end_time",
                placeholder: () => this.$tz("结束时间"),
                component: "DatePicker",
                bind: {
                  type: "date",
                },
                methods: {
                  format: ({ value }) => new Date(value).getTime(),
                },
                required: true,
                minWidth: 150,
              },
              {
                key: "remarks",
                name: () => this.$tz("备注"),
                placeholder() {
                  return this.$tz("备注");
                },
                component: "Input",
                bind: {
                  type: "textarea",
                  autosize: { minRows: 1, maxRows: 2 },
                },
                minWidth: 150,
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "success",
                    },
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "deleteFun",
                    bind: {
                      type: "error",
                    },
                    disabled() {
                      return this.$modal.list.length === 1;
                    },
                  },
                ],
                methods: {
                  add({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex + 1, 0, {
                      start_time: "",
                      end_time: "",
                      expense_item_id: "",
                      charge_mode: "",
                      charge_value: 0,
                      charge_currency: "",
                      remarks: "",
                      status: "",
                    });
                  },
                  deleteFun({ rowIndex }) {
                    this.getModal("add").list.splice(rowIndex, 1);
                  },
                },
              },
            ],
          },
        },
      },
      header: {
        searchs: [
          {
            key: "shipment_type",
            component: "Select",
            placeholder() {
              return this.$t("order_type_t");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:140px",
            },
            config: {
              label: "value",
              value: "key",
            },
          },
          {
            key: "target_type",
            component: "Select",
            placeholder: () => this.$t("select") + this.$t("CollectionUser"),
            clearable: true,
            default: 1,
            options: [
              { label: this.$t("b2bClient"), value: 1 },
              { label: this.$t("branchOffice"), value: 2 },
            ],
          },
          {
            key: "client_id",
            component: "Select",
            placeholder: (data) => {
              return this.$t("select") + this.$t("b2bClient");
            },
            show({ searchForm }) {
              return searchForm.target_type === 1;
            },
            options: [],
            config: {
              label: "account",
              value: "id",
            },
          },
          {
            key: "company_id",
            component: "Select",
            placeholder: (data) => {
              return this.$t("select") + this.$t("branchOffice");
            },
            show({ searchForm }) {
              return searchForm.target_type === 2;
            },
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          // {
          //   key: "keywords",
          //   placeholder() {
          //     return this.$t("keyword");
          //   },
          //   bind: {
          //     type: "textarea",
          //     rows: 1,
          //   },
          //   component: "Input",
          // },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              fnName: "add",
              type: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$t("add"));
                this.list.push({
                  start_time: "",
                  end_time: "",
                  expense_item_id: "",
                  charge_mode: "",
                  charge_value: 0,
                  charge_currency: "",
                  remarks: "",
                });
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
        },
        {
          name: this.$t("order_type_t"),
          key: "shipment_type",
          minWidth: 120,
        },
        {
          name: this.$t("CollectionUser"),
          key: "target_type",
          minWidth: 120,
          methods: {
            render({ value }) {
              return value === 1
                ? this.$t("b2bClient")
                : this.$t("branchOffice");
            },
          },
        },
        {
          name: this.$t("alipay_name"),
          key: "client_account",
          minWidth: 120,
        },
        {
          name: this.$t("currency_t"),
          key: "currency",
          minWidth: 120,
        },
        {
          name: this.$t("操作费收费模式"),
          key: "op_fee_charge_mode_txt",
          minWidth: 120,
        },
        {
          name: this.$t("extra_charge"),
          key: "op_fee",
          minWidth: 120,
        },
        {
          name: this.$t("material_fee"),
          key: "material_fee",
          minWidth: 120,
        },
        {
          name: this.$t("overweight_fee"),
          key: "overweight_fee",
          minWidth: 120,
        },
        {
          name: this.$t("overload_fee"),
          key: "overload_fee",
          minWidth: 120,
        },
        {
          name: this.$t("numMax") + this.$t("overload_fee"),
          key: "max_overload_fee",
          minWidth: 120,
        },
        {
          name: this.$t("status_operator"),
          key: "operator_name",
          minWidth: 120,
        },
        {
          name: this.$t("createTime"),
          key: "create_time",
          minWidth: 120,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$tz("复制"),
              type: "copy",
              fnName: "copy",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
              // id:1258
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              // id:1259
            },
          ],
          methods: {
            copy({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                (res) => {
                  delete res.payload.id;
                  if (
                    !res.payload.other_fee_rules ||
                    !res.payload.other_fee_rules.length
                  ) {
                    res.payload.other_fee_rules.push({
                      start_time: "",
                      end_time: "",
                      expense_item_id: "",
                      charge_mode: "",
                      charge_value: 0,
                      charge_currency: "",
                      remarks: "",
                      status: 1,
                    });
                  }
                  this.getModal("add").open(res.payload, function () {
                    this.list = res.payload.other_fee_rules;
                    this.setTitle(this.$tz("新增"));
                  });
                }
              );
            },
            async updateFun({ row }) {
              this.handleRequestMethods("getDetails", row.id, false, true).then(
                (res) => {
                  if (
                    !res.payload.other_fee_rules ||
                    !res.payload.other_fee_rules.length
                  ) {
                    res.payload.other_fee_rules = [
                      {
                        start_time: "",
                        end_time: "",
                        expense_item_id: "",
                        charge_mode: "",
                        charge_value: 0,
                        charge_currency: "",
                        remarks: "",
                        status: "",
                      },
                    ];
                  }
                  this.getModal("add").open(res.payload, function () {
                    this.list = res.payload.other_fee_rules;
                    this.setTitle(this.$t("update"));
                  });
                }
              );
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") + this.$t("confirm") + this.$t("delete"),
                onOk: () => {
                  this.handleRequestMethods("del", row, true).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped></style>
